{
  "version": "4.7.0-alpha.772",
  "scripts": {
    "sonar-scanner": "sonar-scanner"
  },
  "buildDate": "2.11.2026, 23:22:26",
  "commitId": "9bd58a37908a2e456a81a29582af2a9636cb5327"
}
